<template lang="">
	<div>
    <button @click="closeForm">
      <img style="width: 40px" src="../../../../static/images/close-grey.svg" />
    </button>
    <v-card class="mt-8 mx-8">
      <div width="550" class="d-flex flex-column px-8 py-8">
        <div class="d-flex flex-column mr-8" >
          <label class="font-weight-black">Copy*</label>
          <v-select
            v-model="item.copy.copy_name"
            class="b-4 mt-3 pt-1"
            style="width: 475px; height: 48px;"
            :options="copiesList"
            @change="updateCommunicationCopy"
          />
        </div>
        <div class="d-flex flex-column mr-8 mt-8">
          <label class="font-weight-black">ID Promo*</label>
          <input
            v-model="item.communication_id_shot"
            type="text"
            class="inputCommunication mt-3"
          >
        </div>
        <div class="d-flex flex-column mr-8 mt-8" v-if="channel === 'EMAIL' ? false : true">
          <label class="font-weight-black">Call to action / Link*</label>
          <input
            v-model="item.communication_call_to_link"
            type="text"
            class="inputCommunication mt-3"
          >
        </div>
        <div class="d-flex flex-column mr-8 mt-8">
          <label class="font-weight-black">Mensagem<span v-if="channel === 'SMS'" class="textAreaLength"> {{textAreaLength}}/{{channel !== 'EMAIL' ? 127 : 200}}</span></label>
					<textarea
            v-model="item.communication_text"
						outlined
						height="192px"
						class="rounded mt-3 pa-1 b textareaEdit"
						rows="8"
						:maxlength="maxLengthTextArea"
						placeholder="Texto da mensagem"
					></textarea>
        </div>
        <div class="d-flex flex-row align-center mt-7 justify-space-between">
          <label class="font-weight-black mr-4">Status</label>
          <v-switch
            v-model="item.communication_is_active"
            color="var(--blue)"
            inset
            class="mt-3 mr-10"
            :options="options"
          ></v-switch>
          <label class="font-weight-black mr-4">Fórmula de Lançamento</label>
          <v-switch
            v-model="item.communication_is_formula_lancamento"
            :options="genericOptions"
            color="var(--blue)"
            inset
            class="mt-3 mr-10"
          ></v-switch>
        </div>
        <div class="d-flex flex-row align-center mt-7 justify-space-between">
          <label class="font-weight-black mr-2">Aprovado</label>
          <v-switch
            v-model="item.communication_approval"
            :options="genericOptions"
            color="var(--blue)"
            inset
            class="mt-3 mr-10"
          ></v-switch>
          <label class="font-weight-black mr-4">Relacionamento</label>
          <v-switch
            v-model="item.communication_relationship"
            :options="genericOptions"
            color="var(--blue)"
            inset
            class="mt-3 mr-10"
          ></v-switch>
        </div>
      </div>
    </v-card>
    <v-btn
      class="mt-4 ml-8"
      height="62"
      width="95"
      color="var(--red)"
      @click="onSubmit"
    >
      Enviar
    </v-btn>
	</div>
</template>
<script>
// Lib
import { mapActions, mapState, mapMutations } from 'vuex'
import StringHelper from '@/helpers/string'

import VueCookies from 'vue-cookies'

export default {
	data () {
		return {
      disabled: false,
      options: [
        {
          value: 'true',
          text: 'Ativo'
        },
        {
          value: 'false',
          text: 'Inativo'
        }
      ],
      genericOptions: [
        {
          value: 'true',
          text: 'Sim'
        },
        {
          value: 'false',
          text: 'Não'
        }
      ],
      textmessage: ''
    }
  },
  computed: {
    ...mapState('Copy', {
      copyItems: 'items'
    }),
    ...mapState('Communication', {
      item: 'communicationToEdit',
      loading: 'loading'
    }),
    copiesList () {
      const copies = this.copyItems.data ? this.copyItems.data : [] 
      return copies.map(copy => ({
        value: copy.copy_id,
        label: copy.copy_name
      }))
    },
    textAreaLength () {
      return this.textmessage.length
    },
    channel () {
      return this.item.communication_type
    },
    maxLengthTextArea () {
      return this.channel === 'SMS' ? 127 : 10000000000
		},
  },
  methods: {
    ...mapActions('Communication', [
      'getCommunications',
      'updateCommunication',
      'disableCommunication'
    ]),
    ...mapMutations('Communication', {
      unsetCommunicationToEdit: 'UNSET_COMMUNICATION_TO_EDIT',
      setLoading: 'SET_LOADING'
    }),
    ...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
    updateCommunicationCopy(option) {
      this.item.copy.copy_id = option
    },
    validate () {
      if (
        this.checkContent() &&
        this.checkId() &&
        this.checkCopy()
      ) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    checkContent () {
      return this.item.communication_text.length > 0
    },
    checkId () {
      return this.item.communication_id_shot.length > 0
    },
    checkCopy () {
      return this.item.copy.copy_id !== null && this.item.copy.copy_id !== ''
    },
    async onSubmit () {
      const token = VueCookies.get('jwt-login')

      this.setLoading(true)
      this.disabled = true
      await this.handleUpdate()
      if (!JSON.parse(this.item.communication_is_active)) {
        await this.handleDisable()
      }
      this.setLoading(false)
      this.closeModal()
      await this.getCommunications({token: token})
    },
    async handleUpdate() {
      // const token = window.localStorage.getItem('authToken')
      const token = VueCookies.get('jwt-login')
      try {
        const response = await this.updateCommunication([
            {
            ...this.item,
            copy: {
              copy_id: this.item.copy.copy_id
            },
            communication_text: this.item.communication_text,
            communication_text_normalized: this.smsMessage,
            communication_id_shot: this.item.communication_id_shot,
            communication_comment_shot: this.item.communication_comment_shot,
            communication_call_to_link: this.item.communication_call_to_link,
            communication_type: this.item.communication_type,
            communication_is_active: JSON.parse(this.item.communication_is_active),
            communication_is_formula_lancamento: JSON.parse(this.item.communication_is_formula_lancamento),
            communication_approval: JSON.parse(this.item.communication_approval),
            communication_relationship: JSON.parse(this.item.communication_relationship)
          },
          token
        ])
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Comunicação atualizada com sucesso',
            'var(--green)',
            true
          )
          window.scrollTo(0, 0)
        }
        await this.getCommunications({token: token})
      } catch (error) {
        return error
      }
    },
    async handleDisable() {
      const token = VueCookies.get('jwt-login')
      // const token = window.localStorage.getItem('authToken')
      try {
        const response = await this.disableCommunication([
          this.item,
          token
        ])
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Comunicação atualizada com sucesso',
            'var(--green)',
            true
          )
        }
        window.scrollTo(0, 0)
      } catch (e) {
        this.toaster(e.message, 'var(--red)', true)
      }
    },
    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
    closeForm () {
      this.unsetCommunicationToEdit()
      this.$emit('close')
    },
    closeModal () {
      this.$emit('close')
    },
  },
  watch: {
    'item.communication_id_shot' () {
      this.validate()
    },
    'item.communication_text' () {
      this.validate()
      this.smsMessage = StringHelper.removeSpecialCharacters(this.item.communication_text.split('–').join('-'))
    },
    'item.copy.copy_id' () {
      this.validate()
    },
    'item.communication_call_to_link' () {
      this.validate()
    }
  }
}
</script>
<style lang="scss" scoped>
  // .vs__select {
    .vs__dropdown-toggle {
      padding-top: 7px
    }
  // }

	.inputCommunication {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
    width: 475px !important; 
    height: 48px;
    padding: 15px;
    background: transparent;
    font-family: var(--dm-sans-regular);
    color: var(--grey);
  }

  .v-overlay__scrim {
    height: 200%
  }

  .textareaEdit {
    width: 475px;
    border: 2px solid var(--grey-day-030);
  }
</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/CommunicationForm.vue